

const DateFmt = (date) => {
    // Quebra a string em ano, mês e dia
    let ano = date.substring(0, 4);
    let mes = date.substring(4, 6);
    let dia = date.substring(6, 8);

    // Retorna no formato dd/MM/yyyy
    return `${dia}/${mes}/${ano}`;
};

const formatNum = (numString) => {
  let num = Number(numString);

  if (num < 10 && num >= 0) {
    return `0${num}`;
  } else if (num >= -9 && num < 0) {
    return `-0${Math.abs(num)}`;
  }

  return numString;
};

const FormatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  if(isNaN(date)){
    return "Data Invalida"
  }

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${formatNum(day)}/${formatNum(month)}/${year} - ${formatNum(hours)}:${formatNum(minutes)}`;
};

const DateFromMinutes = (minutes) => {
  const day = Math.floor(minutes / (24 * 60));
  const hours = Math.floor((minutes % (24 * 60)) / 60);
  const minutesRest = minutes % 60;

  let timeFormate = "";

  if (day > 0) {
    timeFormate += `${day} `;
  }

  timeFormate += `${hours.toString().padStart(2, "0")}:${minutesRest
    .toString()
    .padStart(2, "0")}`;

  return timeFormate;
};

//entrada e saida
//  2021-11-24T04:39:23.35
//2021/11/24 - 04:39
const DateTimeFmt = (date) => {
  if (!date) return "";

  const dateStr = typeof date === "string" ? date : date.toString();

  let day = dateStr.substring(8, 10);
  let month = dateStr.substring(5, 7);
  let year = dateStr.substring(0, 4);

  let hours = dateStr.substring(11, 13);
  let minutes = dateStr.substring(14, 16);

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
};

const fmt0left = (date, number) => date.toString().padStart(number, "0");

const fmtDate0left = (date) => date.toString().padStart(2, "0");

const remove0fromLeft = (str) => str.replace(/^0+/, "");


const TimeFmt = (time) => {
  let hours = Add0Left(time / 60);

  let minutes = Add0Left(time % 60);

  hours = Math.trunc(hours);

  let fmtTime = `${hours}:${minutes}`;

  return fmtTime;
};

const Add0Left = (data) => {
  data = data.toString();

  if (data.length < 2) {
    data = "0" + data;
  }

  return data;
};

const addLeadingZeros = (data, quantity) => {
  data = data.toString();
  const missingZeros = Number.parseInt(quantity) - data.length;

  if (missingZeros <= 0) {
    return data;
  }

  const zeros = "0".repeat(missingZeros);
  return zeros + data;
};


const GetDateNow = () => {
  const date = new Date();

  let day = Add0Left(date.getDate());

  let month = Add0Left(date.getMonth() + 1);

  let year = date.getFullYear();

  let currentDate = `${year}${month}${day}`;

  return currentDate;
};

const GetTimeNow = () => {
  const date = new Date();

  let hours = date.getHours();

  let minutes = date.getMinutes();

  let time = hours * 60 + minutes;

  return time;
};
const getDataFormatBr = () => {
  const dataAtual = new Date();
  const dia = String(dataAtual.getDate()).padStart(2, "0");
  const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
  const ano = dataAtual.getFullYear();

  return `${dia}/${mes}/${ano}`;
};

const getTimeFromDateTime = (dateTime) => {
  var time = null;
  if (dateTime !== null) {
    time = dateTime.slice(11, 16);
  }
  return time;
};

const getTimeFromDateTimeLocate = (dateTime) => {
  var time = null;
  if (dateTime !== null) {
    time = dateTime.slice(12, 17);
  }
  return time;
};

const getDateFromDateTime = (dateTime) => {
  var time = null;
  if (dateTime !== null) {
    time = dateTime.slice(0, 10);
    time = time.replace("-", "/");
    time = time.replace("-", "/");
  }
  return time;
};

const converteSlashToDot = (num) => {
  if (num) {
    return parseFloat(num).toFixed(2).replace(",", ".");
  } else {
    return 0;
  }
};

const getDayNow = () => {
  const timeElapsed = Date.now();

  const date = new Date(timeElapsed);
  const day = formatNum(date.getDate());
  const month = formatNum(date.getMonth() + 1);
  const year = date.getFullYear();
  const hour = formatNum(date.getHours());
  const minute = formatNum(date.getMinutes());

  return `${day}/${month}/${year} - ${hour}:${minute}`;
}

export {
  DateFmt,
  DateTimeFmt,
  TimeFmt,
  fmt0left,
  Add0Left,
  addLeadingZeros,
  GetDateNow,
  GetTimeNow,
  fmtDate0left,
  getTimeFromDateTime,
  getDateFromDateTime,
  remove0fromLeft,
  converteSlashToDot,
  getDataFormatBr,
  DateFromMinutes,
  FormatDate,
  getDayNow,
  formatNum,
  getTimeFromDateTimeLocate
};
